/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

const useRemoveScrollByDialogs = (dialogShowToObserve = []) => {
    useEffect(() => {
        // Manejando visibilidad del scrollbar del body
        const { classList } = document.body;
        if (classList.contains("no-scroll")) return;
        dialogShowToObserve.forEach(dialogShow => {
            if (!dialogShow)
                classList.add("no-scroll");
        });
    }, dialogShowToObserve);
}

export default useRemoveScrollByDialogs;